import React from 'react';

export default function Image({ slice }) {
  return (
    <div className="additional-info-book-image">
      <img src={slice.single_book_description.raw} alt="hello" />
    </div>
  );
}
